import dayjs from "dayjs"

const ISO = "YYYY-MM-DD"

// Block reasons (booking_details available_slots) that stop a stay STARTING on a day while the day
// itself is free: it can still sit inside a stay that starts earlier. The calendar shows such a day
// as a normal date the guide can't start on, not as a greyed-out one (QA Ticketing #47).
export const START_ONLY_REASONS = ["span_blackout"]

// How far either side of a refused start the "Start on …" suggestion looks.
const NEAREST_START_WINDOW = 14

export const isStartOnlyReason = (reason) => START_ONLY_REASONS.includes(reason)

/**
 * The first day of a `length`-day stay from `start` that nothing can use (a blackout, a booked or
 * out-of-season day): `{ iso, reason }`, or null when every day the feed describes is free.
 */
export const findSpanConflict = (start, length, blockedReasons, takenDates) => {
  for (let offset = 0; offset < length; offset += 1) {
    const iso = dayjs(start).add(offset, "day").format(ISO)
    const reason = blockedReasons?.[iso]
    if (reason && !isStartOnlyReason(reason)) return { iso, reason }
    if (!reason && takenDates?.has(iso)) return { iso, reason: "booked" }
  }
  return null
}

/**
 * The legal start nearest to `day` (earlier wins a tie), within two weeks either side; null when
 * there is none or the feed gives no start list. Past days only count when `allowPastDates`.
 */
export const findNearestStart = (day, allowedStarts, allowPastDates) => {
  if (!allowedStarts) return null
  const today = dayjs().startOf("day")
  for (let distance = 1; distance <= NEAREST_START_WINDOW; distance += 1) {
    for (const candidate of [dayjs(day).subtract(distance, "day"), dayjs(day).add(distance, "day")]) {
      if (allowedStarts.has(candidate.format(ISO)) && (allowPastDates || !candidate.isBefore(today))) return candidate
    }
  }
  return null
}
